import React, { useState, useEffect } from 'react';
import '../styles/Nav.css';
import logo from '../otherIMG/logo.png';
import options from '../otherIMG/options.png'
import { motion } from 'framer-motion'; // Import Framer Motion

function NavMenu() {
  const [hideNav, setHideNav] = useState(false);

  useEffect(() => {
    let lastScrollTop = 0;
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;

      if (currentScrollTop > lastScrollTop) {
        setHideNav(true); // Scrolling down
      } else {
        setHideNav(false); // Scrolling up
      }
      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      toggleMobileMenu(); // Close mobile menu after scroll
    } else {
      window.location.href = '/'; // Navigate to homepage if sectionId is not found
    }
  };

  const toggleMobileMenu = () => {
    const x = document.getElementById('myLinks');
    if (x.style.display === 'block') {
      x.style.display = 'none';
    } else {
      x.style.display = 'block';
    }
  };

  return (
    <div className='navColor'>
      {/* Desktop Navigation */}
      <header className="header">
        <nav className="nav">
          <div className="logo">
            <a href="/">
              <img src={logo} alt="Logo" />
            </a>
          </div>

          <ul className="nav-list">
            {/* Using motion.li for animated list items */}
            <motion.li className="nav-item" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
              <a href="/" onClick={(e) => {
                toggleMobileMenu();
                scrollToSection(e, 'galleryBody');
              }} className="nav-link">
                Gallery
              </a>
            </motion.li>
            <motion.li className="nav-item active" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }}>
              <a href="https://www.facebook.com/profile.php?id=61558208233638" target="_blank" rel="noopener noreferrer" className="nav-link">
                FaceBook
              </a>
            </motion.li>
            <motion.li className="nav-item" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }}>
              <a href="tel:+1(678)673-0955" className="nav-link">
                (678) 673-0955
              </a>
            </motion.li>
          </ul>
        </nav>
      </header>

      {/* Mobile Navigation */}
      <div className="mobileNav">
        <div className="topnav">
          <a href="/" className="active mobileNavImg">
            <img src={logo} alt="Logo" />
          </a>
          <motion.div
            id="myLinks"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, staggerChildren: 0.2 }}
          >
            <motion.a
              href="/"
              onClick={(e) => {
                toggleMobileMenu();
                scrollToSection(e, 'galleryBody');
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              Gallery
            </motion.a>
            <motion.a
              href="https://www.facebook.com/profile.php?id=61558208233638" target="_blank" rel="noopener noreferrer"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              FaceBook
            </motion.a>
            <motion.a
              href="tel:+1(678)673-0955"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              (678) 673-0955
            </motion.a>
          </motion.div>
          <a href="javascript:void(0);" className="icon" onClick={toggleMobileMenu}>
            <img src={options} alt="Options" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default NavMenu;
